import { Eye } from "lucide-react"

export const EmptyResponse = () => (
  <span className="mb-2 mt-1 inline-flex items-center gap-1 rounded-md border border-orange-200 bg-orange-50 px-2 py-0.5 text-xs text-orange-600">
    <Eye size={12} className="text-orange-600" />
    Needs Review
  </span>
)
